import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

import { paths } from '@/shared/config';
import { EmptyState } from '@/shared/ui/state';

/** Unexpected render or routing failure: a calm message instead of a blank page. */
export function RouteError() {
  const error = useRouteError();
  const title =
    isRouteErrorResponse(error) && error.status === 404
      ? 'Страница не найдена'
      : 'Что-то пошло не так';
  return (
    <EmptyState title={title}>
      <Link to={paths.home}>На главную</Link>
    </EmptyState>
  );
}
